import React, { useEffect, useState } from "react";
import { Plus, LifeBuoy } from "lucide-react";
import api from "../lib/api";
import { PageHeader, Card, Badge, Loading, Modal, fmtDate, EmptyState } from "../components/ui";

const CATS = ["IT", "PAYROLL", "HR", "FACILITIES", "GENERAL"];

export default function Helpdesk() {
  const [items, setItems] = useState(null);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ subject: "", description: "", category: "IT", priority: "MEDIUM" });
  const load = () => api.get("/helpdesk").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);
  const add = async (e) => { e.preventDefault(); await api.post("/helpdesk", form); setOpen(false); setForm({ subject: "", description: "", category: "IT", priority: "MEDIUM" }); load(); };
  const setStatus = async (t, status) => { await api.put(`/helpdesk/${t.id}`, { status }); load(); };
  if (!items) return <Loading />;

  return (
    <div>
      <PageHeader title="Help Desk" subtitle="Raise and track support tickets">
        <button data-testid="add-ticket" onClick={() => setOpen(true)} className="btn-accent"><Plus size={16} /> New Ticket</button>
      </PageHeader>
      {items.length === 0 ? <EmptyState icon={LifeBuoy} title="No tickets" /> : (
        <Card className="overflow-hidden">
          <div className="overflow-x-auto">
          <table className="w-full" data-testid="ticket-table">
            <thead><tr><th className="th">Subject</th><th className="th">Category</th><th className="th">Raised By</th><th className="th">Priority</th><th className="th">Date</th><th className="th">Status</th></tr></thead>
            <tbody className="divide-y divide-slate-100 dark:divide-slate-800">
              {items.map((t) => (
                <tr key={t.id} data-testid={`ticket-${t.id}`}>
                  <td className="td font-medium text-slate-800 dark:text-slate-100">{t.subject}</td>
                  <td className="td"><Badge tone="info">{t.category}</Badge></td>
                  <td className="td">{t.raisedByName || "—"}</td>
                  <td className="td"><Badge value={t.priority} /></td>
                  <td className="td">{fmtDate(t.createdAt)}</td>
                  <td className="td"><select value={t.status} onChange={(e) => setStatus(t, e.target.value)} data-testid={`ticket-status-${t.id}`} className="rounded border border-slate-200 bg-transparent px-2 py-1 text-xs dark:border-slate-700">{["OPEN", "IN_PROGRESS", "RESOLVED"].map((s) => <option key={s}>{s}</option>)}</select></td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </Card>
      )}
      <Modal open={open} onClose={() => setOpen(false)} title="New Ticket"
        footer={<><button onClick={() => setOpen(false)} className="btn-outline">Cancel</button><button form="tk-form" className="btn-accent">Submit</button></>}>
        <form id="tk-form" onSubmit={add} className="space-y-4">
          <div><label className="label">Subject *</label><input required data-testid="tk-subject" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} className="input" /></div>
          <div className="grid grid-cols-2 gap-4">
            <div><label className="label">Category</label><select data-testid="tk-category" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} className="input">{CATS.map((c) => <option key={c}>{c}</option>)}</select></div>
            <div><label className="label">Priority</label><select value={form.priority} onChange={(e) => setForm({ ...form, priority: e.target.value })} className="input">{["LOW", "MEDIUM", "HIGH", "URGENT"].map((p) => <option key={p}>{p}</option>)}</select></div>
          </div>
          <div><label className="label">Description</label><textarea data-testid="tk-desc" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} className="input h-24 py-2" /></div>
        </form>
      </Modal>
    </div>
  );
}
